import { ClickAwayListener, Popover } from "@mui/material";
import {
    StyledList,
    StyledListItem,
    StyledListItemButton,
    StyledListItemText,
    StyledPopoverSortOrder,
} from "./FilterSearchSortOrderPopup.style";
import { MiscSavio } from "../../../../configuration/themeSettings";

type Props = {
    anchorEl: null | HTMLElement;
    onCancel:any;
    open: boolean;
    handlePopupClose: any;
    sortOrders: optionType[];
    sortOrderSelected: optionType;
};
type optionType = {
    id: string;
    label: string;
};


export const FilterSearchSortOrderPopup = (props: Readonly<Props>) => {
    return (
        <StyledPopoverSortOrder
            anchorEl={props.anchorEl}
            anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
            }}
            id="FilterSearchSortOrderPopup-ID-LIST"
            transformOrigin={{
                vertical: "top",
                horizontal: "left",
            }}
            open={props.open}
            onClose={()=>{ 
                props.onCancel();
            }}
            disableRestoreFocus
        >
            
            <StyledList>
                {props.sortOrders.map((x: optionType, index: number) => (
                    <StyledListItem
                        key={"blelem_" + x.id}
                        onClick={() => props.handlePopupClose(x)}
                        className={x.id === props.sortOrderSelected.id ? 'selected' : ''}
                      
                    >
                        <StyledListItemButton>
                            <StyledListItemText inset>
                                {x.label}
                            </StyledListItemText>
                        </StyledListItemButton>
                    </StyledListItem>
                ))}
            </StyledList>
        </StyledPopoverSortOrder>
    );
};
